// frontend/src/api/ai.js
import { apiClient } from './index';

const aiApi = {
  chat: async (data) => { 
    return await apiClient.post('/ai/chat', data); 
  },

  getHistory: async (sessionId) => {
    return await apiClient.get(`/ai/history/${sessionId}`);
  },

  /**
   * Generates CMS content based on a prompt and page type.
   */
  generateCMSContent: async (prompt, pageType) => {
    return await apiClient.post('/ai/cms-generate', { prompt, page_type: pageType });
  },

  /**
   * Generates inspection notes or verdict.
   */
  generateInspectionNotes: async (data) => {
    return await apiClient.post('/ai/generate-inspection-notes', data);
  },
  
  /**
   * Generates a professional description for a part or vehicle.
   */
  generateDescription: async (data) => {
    return await apiClient.post('/ai/generate-description', data);
  },

  /**
   * Customer-facing: generate several sales descriptions to choose from.
   * data: { make, model, year, condition, transmission, mileage, color, price, features, count }
   */
  generateVehicleDescriptions: async (data) => {
    return await apiClient.post('/ai/vehicle-descriptions', data);
  },

  /**
   * Checks if a part fits a vehicle.
   * @param {Object} data - { part_id, user_vehicle_id, manual_make, manual_model, manual_year }
   */
  checkCompatibility: async (data) => {
    return await apiClient.post('/ai/check-compatibility', data);
  }
};

export { aiApi };